module.exports = __webpack_public_path__ + "static/media/upl_blanco.5ded77c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/logos/upl_blanco.png
// module id = 2798
// module chunks = 3